import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Grid,
  Typography,
  colors,
  IconButton,
} from "@mui/material";
import { InputAdornment } from "@mui/material";
import DebugLog from "../../utils/DebugLog";
import { DateRange } from "@mui/icons-material";
import ToAndFromDatePickerDialog from "./ToAndFromDatePickerDialog";
import dayjs from "dayjs";

function AddExclusionDialog({
  openExclusion,
  closeExclusion,
  onSubmitExclusion,
}) {
  const [formData, setFormData] = useState({
    customer: "",
    yesId: "",
    billingAccountNo: "",
    reason: "",
    yesId: "",
    from: "",
    to: "",
  });
  const [errors, setErrors] = useState({});

  const [open, setOpen] = useState(false);
  const [type, setType] = useState(0);
  const [selectedFromDate, setSelectedFromDate] = useState("");
  const [selectedToDate, setSelectedToDate] = useState("");

  // auto update dealer name in the form
  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      customer: "",
      yesId: "",
      billingAccountNo: "",
      reason: "",
      yesId: "",
      from: "",
      to: "",
    }));
  }, [openExclusion]);

  const handleClose = () => {
    setOpen(false);
    DebugLog("Dialog Closed");
  };
  function chooseFromDateOptionClicked() {
    setType(0);
    setOpen(true);
  }
  function chooseToDateOptionClicked() {
    setType(1);
    setOpen(true);
  }
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    // Validation logic
    const newErrors = {};
    if (!formData.customer.trim()) {
      newErrors.customer = "Customer Name is required";
    } else if (!formData.yesId.trim()) {
      newErrors.yesId = "Yes ID is required";
    } 
    else if (!validateEmail(formData.yesId.trim())) {
      newErrors.yesId = "Please enter a valid email address";
    } 
    
    
    else if (!formData.billingAccountNo.trim()) {
      newErrors.billingAccountNo = "Billing Account number is required";
    } else if (!formData.reason.trim()) {
      newErrors.reason = "Reason is required";
    } 
    formData.from = selectedFromDate;
    formData.to = selectedToDate;

   // var expiryStartDateString = newRow.expiryStartDate;
    // var expiryEndDateString = newRow.expiryEndDate;

    const startDate = dayjs(selectedFromDate);
    const endDate = dayjs(selectedToDate);


   
    if (formData.from.trim()==="") {
      newErrors.from = "From date is required";
    }  else  if (formData.to.trim()==="") {
      newErrors.to = "To date is required";
    }
   else if (startDate.isAfter(endDate)) {
      // showErrorAlert(
      //   "Error",
      //   "FROM date should always be less than the END date!"
      // );
      newErrors.from = "FROM date should always be less than the END date!";
    }
    if (Object.keys(newErrors).length === 0) {
      // Form is valid, submit the data
      onSubmitExclusion(formData);

      // Close the dialog
      closeExclusion();
      // You can perform additional actions like sending data to a server here
    } else {
      // Form is not valid, update the errors state
      setErrors(newErrors);
    }
  };
  const handleDateSelect = (date, type) => {
    if (type === 0) {
      setSelectedFromDate(date);
      DebugLog("Selected Date " + selectedFromDate);
    } else {
      setSelectedToDate(date);
      DebugLog("Selected Date " + selectedToDate);
    }
  };

  return (
    <Box>
      <ToAndFromDatePickerDialog
        open={open}
        onClose={handleClose}
        onSelect={handleDateSelect}
        type={type}
      />

      <Dialog open={openExclusion} close={closeExclusion}>
        <DialogContent>
          <Box>
            <Grid container justifyContent="center" alignItems="center" item>
              <Typography fontWeight={"600"} variant="h3" p={1}>
                Add Exclusion
              </Typography>
            </Grid>
            <Grid container justifyContent="center" alignItems="center" item>
              <Typography fontSize={"16px"} fontWeight={"400"} pb={4}>
                Please specify Exclusion for the customer
              </Typography>
            </Grid>
          </Box>
          <form onSubmit={handleSubmit}>
            <Grid container xs={12} alignItems={"center"} spacing={3} pb={0.5}>
              <Grid item xs={3}>
                <Typography
                  color={colors.grey[900]}
                  fontWeight={"600"}
                  variant="h7"
                  sx={{ textAlign: "right" }}
                >
                  Customer
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  autoFocus
                  margin="dense"
                  label="Customer"
                  type="text"
                  name="customer"
                  fullWidth
                  value={formData.customer}
                  onChange={handleInputChange}
                  error={Boolean(errors.customer)}
                  helperText={errors.customer}
                  // InputProps={{
                  //   readOnly: Boolean(customer),
                  // }}
                />
              </Grid>
            </Grid>

            <Grid container xs={12} alignItems={"center"} spacing={3} pb={0.5}>
              <Grid item xs={3}>
                <Typography
                  color={colors.grey[900]}
                  fontWeight={"600"}
                  variant="h7"
                  sx={{ textAlign: "right" }}
                >
                  Yes Id
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  margin="dense"
                  label="Yes Id"
                  type="email"
                  name="yesId"
                  fullWidth
                  value={formData.yesId}
                  onChange={handleInputChange}
                  error={Boolean(errors.yesId)}
                  helperText={errors.yesId}
                />
              </Grid>
            </Grid>

            <Grid container xs={12} alignItems={"center"} spacing={3} pb={0.5}>
              <Grid item xs={3}>
                <Typography
                  color={colors.grey[900]}
                  fontWeight={"600"}
                  variant="h7"
                  sx={{ textAlign: "right" }}
                >
                  Billing Account
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  margin="dense"
                  label="Billing Account"
                  type="number"
                  name="billingAccountNo"
                  fullWidth
                  value={formData.billingAccountNo}
                  onChange={handleInputChange}
                  error={Boolean(errors.billingAccountNo)}
                  helperText={errors.billingAccountNo}
                />
              </Grid>
            </Grid>

            <Grid container xs={12} alignItems={"center"} spacing={3}>
              <Grid item xs={3}>
                <Typography
                  color={colors.grey[900]}
                  fontWeight={"600"}
                  variant="h7"
                  sx={{ textAlign: "right" }}
                >
                  Reason
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  margin="dense"
                  label="Reason"
                  type="text"
                  name="reason"
                  fullWidth
                  value={formData.reason}
                  onChange={handleInputChange}
                  error={Boolean(errors.reason)}
                  helperText={errors.reason}
                />
              </Grid>
            </Grid>

            <Grid
              container
              xs={12}
              alignItems={"center"}
              spacing={3}
              mt={0.0}
              pb={0.5}
            >
              <Grid item xs={3}>
                <Typography
                  color={colors.grey[900]}
                  fontWeight={"600"}
                  variant="h7"
                  sx={{ textAlign: "right" }}
                >
                  Exclusion
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      inputProps={{ style: { height: "20px" } }}
                      margin="dense"
                      label="From"
                      name="from"
                      type="text"
                      fullWidth
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton>
                              <DateRange
                                onClick={chooseFromDateOptionClicked}
                              />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      value={selectedFromDate}
                      onChange={handleInputChange}
                      error={Boolean(errors.from)}
                      helperText={errors.from}
                    />
                  </Grid>
                  <Grid item xs={6} mt={1}>
                    <TextField
                      inputProps={{ style: { height: "20px" } }}
                      fullWidth
                      label="To"
                      name="to"
                      type="text"
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton>
                              <DateRange onClick={chooseToDateOptionClicked} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      value={selectedToDate}
                      onChange={handleInputChange}
                      error={Boolean(errors.to)}
                      helperText={errors.to}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* Add more fields as needed */}
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeExclusion} color="primary">
            Cancel
          </Button>
          <Button
            variant="contained"
            type="submit"
            onClick={handleSubmit}
            color="primary"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default AddExclusionDialog;
